export default {
    path: '/404',
    meta: {
        title: '404',
        keepAlive: false
    },
    component: () => import("@/views/404/index.vue")
}